import { Toast } from 'antd-mobile';
import { specialOfferList, orderInit } from '@/services/api';

const specialRecharge = {
  namespace: 'specialRecharge',
  state: {
    specialRechargeInfo: {}
  },
  reducers: {
    updateSpecialRechargeInfo(state, { payload }) {
      return {
        ...state,
        specialRechargeInfo: payload
      };
    }
  },
  effects: {
    *getSpecialRechargeInfo({ payload }, { call }) {
      const { data, error } = yield call(specialOfferList, payload);
      if (error) {
        Toast.show({
          content: error
        });
        return false;
      }
      return data;
    },
    *orderInit({ payload }, { call }) {
      const { data = {}, error } = yield call(orderInit, payload);
      if (error) {
        Toast.show({
          content: error
        });
        return false;
      }
      return data;
    }
  }
};

export default specialRecharge;
